module.exports = __webpack_public_path__ + "static/media/BERGUI_MENU-normal.dbaf31a6.png";